<script lang="ts">
	import ProductCard from '$lib/components/product/ProductCard.svelte'
	import type { BaseProduct, LinkedProduct } from '$lib/js/elasticsearch/types'

	interface Props {
		title?: string;
		description?: string;
		products?: BaseProduct[] | LinkedProduct[];
	}

	let { title = '', description = '', products = [] }: Props = $props();
</script>

<div class="products-rows">
	{#if title}
		<div class="title-wrapper">
			<h2 class="title head-4">{title}</h2>

			{#if description}
				<div class="description">{@html description}</div>
			{/if}
		</div>
	{/if}

	<div class="products-rows__inner">
		{#if products.length === 1}
			<div class="card-single">
				<ProductCard lazy={true} product={products[0]} />
			</div>
		{:else if (products.length === 2 || products.length === 3)}
			<div class="card-single__group">
				{#each products as product}
					<div class="card-single">
						<ProductCard lazy={true} {product} />
					</div>
				{/each}
			</div>
		{:else}
			<div class="products-rows__inner__row">
				{#each products as product}
					<div class="row-card">
						<ProductCard {product} lazy={true} />
					</div>
				{/each}
			</div>
		{/if}
	</div>
</div>

<style lang="scss">
	.promo {
		.title-wrapper {
			display: flex;
			flex-wrap: wrap;
			align-items: center;

			h2.title {
				margin: 10px 30px 10px 0;
				color: var(--main);
			}
		}
	}

	.card-single {
		max-width: 50%;

		@media (min-width: 769px) {
			max-width: 260px;
			width: 100%;
		}

		&__group {
			display: flex;
			flex-wrap: wrap;
		}
	}

	.products-rows {
		text-align: left;

		.title {
			margin: 0 0 15px;
			color: black;
		}

		.description {
			max-width: 650px;
			margin: 0 0 25px;
		}

		&__inner {
			margin-right: -12px;

			&__row {
				@media (min-width: 450px) {
					display: flex;
					flex-wrap: wrap;
					row-gap: 18px;
					column-gap: 10px;
				}

				.row-card {
					@media (max-width: 449px) {
						margin-bottom: 12px;
					}

					@media (min-width: 450px) {
						width: calc(50% - 10px);
					}

					@media (min-width: 1025px) {
						width: calc(33.3% - 10px);
					}

					@media (min-width: 1300px) {
						width: calc(25% - 10px);
					}
				}
			}
		}
	}
</style>
